import React, { useContext, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import Header from '../components/layout/Header';
import ProjetsSection from '../components/sections/ProjectsSection';

const Projets = () => {

  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 4, px: { xs: 2, sm: 3 } }}>
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem' } }}>Projets</Typography>
        <ProjetsSection />
      </Container>
    </>
  );
};

export default Projets;